// This file is mostly autogenerated from "yarn import-markets"
// keep that in mind before editing manually!
import { MarketData } from 'etc/types';

export const MARKET_DATA: MarketData = {
  ad: {
    locale: 'es-ES',
    country: 'Andorra',
  },
  'ad-ca': {
    locale: 'es-ES',
    country: 'Andorra',
  },
  'ae-ar': {
    locale: 'ar',
    country: 'United_Arab_Emirates',
    phonePrefix: '+971',
  },
  'ae-en': {
    locale: 'en-US',
    country: 'United_Arab_Emirates',
    phonePrefix: '+971',
  },
  ag: {
    locale: 'en-US',
    country: 'Antigua_and_Barbuda',
  },
  al: {
    locale: 'en-US',
    country: 'Albania',
  },
  am: {
    locale: 'en-US',
    country: 'Armenia',
  },
  'ao-en': {
    locale: 'en-US',
    country: 'Angola',
  },
  'ao-pt': {
    locale: 'en-US',
    country: 'Angola',
  },
  ar: {
    locale: 'es-LA',
    country: 'Argentina',
    phonePrefix: '+54',
  },
  at: {
    locale: 'de-DE',
    country: 'Austria',
  },
  au: {
    locale: 'en-US',
    country: 'Australia',
  },
  'az-az': {
    locale: 'en-US',
    country: 'Azerbaijan',
  },
  'az-en': {
    locale: 'en-US',
    country: 'Azerbaijan',
  },
  ba: {
    locale: 'en-US',
    country: 'Bosnia_and_Herzegovina',
  },
  'ba-bs': {
    locale: 'en-US',
    country: 'Bosnia_and_Herzegovina',
  },
  bb: {
    locale: 'en-US',
    country: 'Barbados',
  },
  'bd-bn': {
    locale: 'en-US',
    country: 'Bangladesh',
  },
  'bd-en': {
    locale: 'en-US',
    country: 'Bangladesh',
  },
  'be-fr': {
    locale: 'fr-FR',
    country: 'Belgium',
  },
  'be-nl': {
    locale: 'nl-NL',
    country: 'Belgium',
  },
  'bf-en': {
    locale: 'en-US',
    country: 'Burkina_Faso',
  },
  'bf-fr': {
    locale: 'fr-FR',
    country: 'Burkina_Faso',
  },
  'bg-bg': {
    locale: 'en-US',
    country: 'Bulgaria',
  },
  'bg-en': {
    locale: 'en-US',
    country: 'Bulgaria',
  },
  'bh-ar': {
    locale: 'ar',
    country: 'Bahrain',
  },
  'bh-en': {
    locale: 'en-US',
    country: 'Bahrain',
  },
  'bi-en': {
    locale: 'en-US',
    country: 'Burundi',
  },
  'bi-fr': {
    locale: 'fr-FR',
    country: 'Burundi',
  },
  'bj-en': {
    locale: 'en-US',
    country: 'Benin',
  },
  'bj-fr': {
    locale: 'fr-FR',
    country: 'Benin',
  },
  'bn-en': {
    locale: 'en-US',
    country: 'Brunei_Darussalam',
  },
  'bn-ms': {
    locale: 'en-US',
    country: 'Brunei_Darussalam',
  },
  bo: {
    locale: 'es-LA',
    country: 'Bolivia',
  },
  'br-en': {
    locale: 'en-US',
    country: 'Brazil',
    phonePrefix: '+55',
  },
  'br-pt': {
    locale: 'pt-BR',
    country: 'Brazil',
    phonePrefix: '+55',
  },
  bs: {
    locale: 'en-US',
    country: 'The_Bahamas',
  },
  bt: {
    locale: 'en-US',
    country: 'Bhutan',
  },
  bw: {
    locale: 'en-US',
    country: 'Botswana',
  },
  'by-en': {
    locale: 'en-US',
    country: 'Belarus',
  },
  'by-ru': {
    locale: 'ru-RU',
    country: 'Belarus',
  },
  'bz-en': {
    locale: 'en-US',
    country: 'Belize',
  },
  'bz-es': {
    locale: 'es-LA',
    country: 'Belize',
  },
  'ca-en': {
    locale: 'en-US',
    country: 'Canada',
  },
  'ca-fr': {
    locale: 'fr-CA',
    country: 'Canada',
  },
  'cd-fr': {
    locale: 'fr-FR',
    country: 'Democratic_Republic_of_Congo',
  },
  'cd-sw': {
    locale: 'en-US',
    country: 'Democratic_Republic_of_Congo',
  },
  'cg-en': {
    locale: 'en-US',
    country: 'Republic_of_the_Congo',
  },
  'cg-fr': {
    locale: 'fr-FR',
    country: 'Republic_of_the_Congo',
  },
  'ch-de': {
    locale: 'de-DE',
    country: 'Switzerland',
  },
  'ch-fr': {
    locale: 'fr-FR',
    country: 'Switzerland',
  },
  'ci-en': {
    locale: 'en-US',
    country: 'Cote_d´Ivoire',
  },
  'ci-fr': {
    locale: 'fr-FR',
    country: 'Cote_d´Ivoire',
  },
  cl: {
    locale: 'es-LA',
    country: 'Chile',
    phonePrefix: '+56',
  },
  'cm-en': {
    locale: 'en-US',
    country: 'Cameroon',
  },
  'cm-fr': {
    locale: 'fr-FR',
    country: 'Cameroon',
  },
  'co-en': {
    locale: 'en-US',
    country: 'Colombia',
    phonePrefix: '+57',
  },
  'co-es': {
    locale: 'es-LA',
    country: 'Colombia',
    phonePrefix: '+57',
  },
  cr: {
    locale: 'es-LA',
    country: 'Costa_Rica',
  },
  'cv-en': {
    locale: 'en-US',
    country: 'Cabo_Verde',
  },
  'cv-pt': {
    locale: 'en-US',
    country: 'Cabo_Verde',
  },
  'cw-en': {
    locale: 'en-US',
    country: 'Curacao',
  },
  'cw-nl': {
    locale: 'nl-NL',
    country: 'Curacao',
  },
  cy: {
    locale: 'en-US',
    country: 'Cyprus',
  },
  cz: {
    locale: 'en-US',
    country: 'Czech_Republic',
  },
  de: {
    locale: 'de-DE',
    country: 'Germany',
  },
  'de-en': {
    locale: 'en-US',
    country: 'Germany',
  },
  'dj-en': {
    locale: 'en-US',
    country: 'Djibouti',
  },
  'dj-fr': {
    locale: 'fr-FR',
    country: 'Djibouti',
  },
  'dk-da': {
    locale: 'en-US',
    country: 'Denmark',
  },
  'dk-en': {
    locale: 'en-US',
    country: 'Denmark',
  },
  dm: {
    locale: 'en-US',
    country: 'Dominica',
  },
  do: {
    locale: 'es-LA',
    country: 'Dominican_Republic',
  },
  'dz-ar': {
    locale: 'ar',
    country: 'Algeria',
    phonePrefix: '+213',
  },
  'dz-fr': {
    locale: 'fr-FR',
    country: 'Algeria',
    phonePrefix: '+213',
  },
  ec: {
    locale: 'es-LA',
    country: 'Ecuador',
    phonePrefix: '+593',
  },
  'ee-en': {
    locale: 'en-US',
    country: 'Estonia',
  },
  'ee-et': {
    locale: 'en-US',
    country: 'Estonia',
  },
  'eg-ar': {
    locale: 'ar',
    country: 'Egypt',
    phonePrefix: '+20',
  },
  'eg-en': {
    locale: 'en-US',
    country: 'Egypt',
    phonePrefix: '+20',
  },
  es: {
    locale: 'es-ES',
    country: 'Spain',
  },
  'es-ca': {
    locale: 'es-ES',
    country: 'Spain',
  },
  'et-am': {
    locale: 'en-US',
    country: 'Ethiopia',
  },
  'et-en': {
    locale: 'en-US',
    country: 'Ethiopia',
  },
  fi: {
    locale: 'fi-FI',
    country: 'Finland',
  },
  fj: {
    locale: 'en-US',
    country: 'Fiji',
  },
  fm: {
    locale: 'en-US',
    country: 'Micronesia,_Fed._Sts.',
  },
  fr: {
    locale: 'fr-FR',
    country: 'France',
  },
  'ga-en': {
    locale: 'en-US',
    country: 'Gabon',
  },
  'ga-fr': {
    locale: 'fr-FR',
    country: 'Gabon',
  },
  gd: {
    locale: 'en-US',
    country: 'Grenada',
  },
  ge: {
    locale: 'en-US',
    country: 'Georgia',
  },
  gh: {
    locale: 'en-US',
    country: 'Ghana',
    phonePrefix: '+233',
  },
  gm: {
    locale: 'en-US',
    country: 'The_Gambia',
  },
  'gn-en': {
    locale: 'en-US',
    country: 'Guinea',
  },
  'gn-fr': {
    locale: 'fr-FR',
    country: 'Guinea',
  },
  'gq-en': {
    locale: 'en-US',
    country: 'Equatorial_Guinea',
  },
  'gq-es': {
    locale: 'es-ES',
    country: 'Equatorial_Guinea',
  },
  gr: {
    locale: 'en-US',
    country: 'Greece',
  },
  gt: {
    locale: 'es-LA',
    country: 'Guatemala',
  },
  'gw-en': {
    locale: 'en-US',
    country: 'Guinea-Bissau',
  },
  'gw-pt': {
    locale: 'en-US',
    country: 'Guinea-Bissau',
  },
  gy: {
    locale: 'en-US',
    country: 'Guyana',
  },
  'hk-en': {
    locale: 'en-US',
    country: 'Hong_Kong',
    phonePrefix: '+852',
  },
  'hk-zh': {
    locale: 'zh-TW',
    country: 'Hong_Kong',
    phonePrefix: '+852',
  },
  hn: {
    locale: 'es-LA',
    country: 'Honduras',
  },
  'hr-en': {
    locale: 'en-US',
    country: 'Croatia',
  },
  'hr-hr': {
    locale: 'en-US',
    country: 'Croatia',
  },
  'ht-en': {
    locale: 'en-US',
    country: 'Haiti',
  },
  'ht-fr': {
    locale: 'fr-FR',
    country: 'Haiti',
  },
  hu: {
    locale: 'hu-HU',
    country: 'Hungary',
  },
  'id-en': {
    locale: 'en-US',
    country: 'Indonesia',
    phonePrefix: '+62',
  },
  'id-id': {
    locale: 'id-ID',
    country: 'Indonesia',
    phonePrefix: '+62',
  },
  ie: {
    locale: 'en-US',
    country: 'Ireland',
  },
  'il-en': {
    locale: 'en-US',
    country: 'Israel',
  },
  'il-he': {
    locale: 'he-IL',
    country: 'Israel',
  },
  'in-en': {
    locale: 'en-US',
    country: 'India',
    phonePrefix: '+91',
  },
  'in-hi': {
    locale: 'en-US',
    country: 'India',
    phonePrefix: '+91',
  },
  'iq-ar': {
    locale: 'ar',
    country: 'Iraq',
  },
  'iq-en': {
    locale: 'en-US',
    country: 'Iraq',
  },
  'is-en': {
    locale: 'en-US',
    country: 'Iceland',
  },
  'is-is': {
    locale: 'en-US',
    country: 'Iceland',
  },
  it: {
    locale: 'it-IT',
    country: 'Italy',
  },
  jm: {
    locale: 'en-US',
    country: 'Jamaica',
  },
  'jo-ar': {
    locale: 'ar',
    country: 'Jordan',
  },
  'jo-en': {
    locale: 'en-US',
    country: 'Jordan',
  },
  jp: {
    locale: 'ja-JP',
    country: 'Japan',
  },
  'ke-en': {
    locale: 'en-US',
    country: 'Kenya',
    phonePrefix: '+254',
  },
  'ke-sw': {
    locale: 'en-US',
    country: 'Kenya',
    phonePrefix: '+254',
  },
  'kg-en': {
    locale: 'en-US',
    country: 'Kyrgyz_Republic',
  },
  'kg-ru': {
    locale: 'ru-RU',
    country: 'Kyrgyz_Republic',
  },
  kh: {
    locale: 'en-US',
    country: 'Cambodia',
  },
  ki: {
    locale: 'en-US',
    country: 'Kiribati',
  },
  'km-en': {
    locale: 'en-US',
    country: 'Comoros',
  },
  'km-fr': {
    locale: 'fr-FR',
    country: 'Comoros',
  },
  kn: {
    locale: 'en-US',
    country: 'St._Kitts_and_Nevis',
  },
  'kr-en': {
    locale: 'en-US',
    country: 'South_Korea',
  },
  'kr-ko': {
    locale: 'ko-KR',
    country: 'South_Korea',
  },
  'kw-ar': {
    locale: 'ar',
    country: 'Kuwait',
  },
  'kw-en': {
    locale: 'en-US',
    country: 'Kuwait',
  },
  'kz-en': {
    locale: 'en-US',
    country: 'Kazakhstan',
  },
  'kz-ru': {
    locale: 'ru-RU',
    country: 'Kazakhstan',
  },
  la: {
    locale: 'en-US',
    country: 'Lao_PDR',
  },
  'lb-ar': {
    locale: 'ar',
    country: 'Lebanon',
  },
  'lb-en': {
    locale: 'en-US',
    country: 'Lebanon',
  },
  lc: {
    locale: 'en-US',
    country: 'St._Lucia',
  },
  li: {
    locale: 'de-DE',
    country: 'Liechtenstein',
  },
  'lk-en': {
    locale: 'en-US',
    country: 'Sri_Lanka',
  },
  'lk-ta': {
    locale: 'en-US',
    country: 'Sri_Lanka',
  },
  lr: {
    locale: 'en-US',
    country: 'Liberia',
  },
  ls: {
    locale: 'en-US',
    country: 'Lesotho',
  },
  'lt-en': {
    locale: 'en-US',
    country: 'Lithuania',
  },
  'lt-lt': {
    locale: 'en-US',
    country: 'Lithuania',
  },
  'lu-de': {
    locale: 'de-DE',
    country: 'Luxembourg',
  },
  'lu-fr': {
    locale: 'fr-FR',
    country: 'Luxembourg',
  },
  'lv-en': {
    locale: 'en-US',
    country: 'Latvia',
  },
  'lv-lv': {
    locale: 'en-US',
    country: 'Latvia',
  },
  'ly-ar': {
    locale: 'ar',
    country: 'Libya',
  },
  'ly-en': {
    locale: 'en-US',
    country: 'Libya',
  },
  'ma-ar': {
    locale: 'ar',
    country: 'Morocco',
    phonePrefix: '+212',
  },
  'ma-fr': {
    locale: 'fr-FR',
    country: 'Morocco',
    phonePrefix: '+212',
  },
  mc: {
    locale: 'fr-FR',
    country: 'Monaco',
  },
  'md-en': {
    locale: 'en-US',
    country: 'Moldova',
  },
  'md-ru': {
    locale: 'ru-RU',
    country: 'Moldova',
  },
  'me-en': {
    locale: 'en-US',
    country: 'Montenegro',
  },
  'me-sr': {
    locale: 'en-US',
    country: 'Montenegro',
  },
  'mg-en': {
    locale: 'en-US',
    country: 'Madagascar',
  },
  'mg-fr': {
    locale: 'fr-FR',
    country: 'Madagascar',
  },
  mh: {
    locale: 'en-US',
    country: 'Marshall_Islands',
  },
  mk: {
    locale: 'en-US',
    country: 'North_Macedonia',
  },
  'mk-mk': {
    locale: 'en-US',
    country: 'North_Macedonia',
  },
  'ml-en': {
    locale: 'en-US',
    country: 'Mali',
  },
  'ml-fr': {
    locale: 'fr-FR',
    country: 'Mali',
  },
  mn: {
    locale: 'en-US',
    country: 'Mongolia',
  },
  'mo-en': {
    locale: 'en-US',
    country: 'Macao_SAR,_China',
  },
  'mo-zh': {
    locale: 'zh-TW',
    country: 'Macao_SAR,_China',
  },
  'mr-ar': {
    locale: 'ar',
    country: 'Mauritania',
  },
  'mr-en': {
    locale: 'en-US',
    country: 'Mauritania',
  },
  mt: {
    locale: 'en-US',
    country: 'Malta',
  },
  mu: {
    locale: 'en-US',
    country: 'Mauritius',
  },
  'mv-ar': {
    locale: 'ar',
    country: 'Maldives',
  },
  'mv-en': {
    locale: 'en-US',
    country: 'Maldives',
  },
  mw: {
    locale: 'en-US',
    country: 'Malawi',
  },
  mx: {
    locale: 'es-LA',
    country: 'Mexico',
    phonePrefix: '+52',
  },
  'mx-en': {
    locale: 'en-US',
    country: 'Mexico',
    phonePrefix: '+52',
  },
  'my-en': {
    locale: 'en-US',
    country: 'Malaysia',
  },
  'my-ms': {
    locale: 'en-US',
    country: 'Malaysia',
  },
  'mz-en': {
    locale: 'en-US',
    country: 'Mozambique',
  },
  'mz-pt': {
    locale: 'en-US',
    country: 'Mozambique',
  },
  'na-af': {
    locale: 'en-US',
    country: 'Namibia',
  },
  'na-en': {
    locale: 'en-US',
    country: 'Namibia',
  },
  'ne-en': {
    locale: 'en-US',
    country: 'Niger',
  },
  'ne-fr': {
    locale: 'fr-FR',
    country: 'Niger',
  },
  ng: {
    locale: 'en-US',
    country: 'Nigeria',
    phonePrefix: '+234',
  },
  ni: {
    locale: 'es-LA',
    country: 'Nicaragua',
  },
  nl: {
    locale: 'nl-NL',
    country: 'Netherlands',
  },
  'nl-en': {
    locale: 'en-US',
    country: 'Netherlands',
  },
  'no-en': {
    locale: 'en-US',
    country: 'Norway',
  },
  'no-nb': {
    locale: 'en-US',
    country: 'Norway',
  },
  'np-en': {
    locale: 'en-US',
    country: 'Nepal',
  },
  'np-ne': {
    locale: 'en-US',
    country: 'Nepal',
  },
  nr: {
    locale: 'en-US',
    country: 'Nauru',
  },
  nz: {
    locale: 'en-US',
    country: 'New_Zealand',
  },
  'om-ar': {
    locale: 'ar',
    country: 'Oman',
  },
  'om-en': {
    locale: 'en-US',
    country: 'Oman',
  },
  pa: {
    locale: 'es-LA',
    country: 'Panama',
  },
  pe: {
    locale: 'es-LA',
    country: 'Peru',
    phonePrefix: '+51',
  },
  pg: {
    locale: 'en-US',
    country: 'Papua_New_Guinea',
  },
  'ph-en': {
    locale: 'en-US',
    country: 'Philippines',
  },
  'ph-tl': {
    locale: 'en-US',
    country: 'Philippines',
  },
  'pk-en': {
    locale: 'en-US',
    country: 'Pakistan',
  },
  'pk-ur': {
    locale: 'en-US',
    country: 'Pakistan',
    mastheadDirOverride: 'rtl',
  },
  pl: {
    locale: 'pl-PL',
    country: 'Poland',
  },
  'ps-ar': {
    locale: 'ar',
    country: 'Palestine',
  },
  'ps-en': {
    locale: 'en-US',
    country: 'Palestine',
  },
  'pt-en': {
    locale: 'en-US',
    country: 'Portugal',
  },
  'pt-pt': {
    locale: 'en-US',
    country: 'Portugal',
  },
  pw: {
    locale: 'en-US',
    country: 'Palau',
  },
  py: {
    locale: 'es-LA',
    country: 'Paraguay',
  },
  'qa-ar': {
    locale: 'ar',
    country: 'Qatar',
  },
  'qa-en': {
    locale: 'en-US',
    country: 'Qatar',
  },
  'ro-en': {
    locale: 'en-US',
    country: 'Romania',
  },
  'ro-ro': {
    locale: 'en-US',
    country: 'Romania',
  },
  'rs-en': {
    locale: 'en-US',
    country: 'Serbia',
  },
  'rs-sr': {
    locale: 'en-US',
    country: 'Serbia',
  },
  rw: {
    locale: 'en-US',
    country: 'Rwanda',
  },
  'sa-ar': {
    locale: 'ar',
    country: 'Saudi_Arabia',
    phonePrefix: '+966',
  },
  'sa-en': {
    locale: 'en-US',
    country: 'Saudi_Arabia',
    phonePrefix: '+966',
  },
  sb: {
    locale: 'en-US',
    country: 'Solomon_Islands',
  },
  'sc-en': {
    locale: 'en-US',
    country: 'Seychelles',
  },
  'sc-fr': {
    locale: 'fr-FR',
    country: 'Seychelles',
  },
  se: {
    locale: 'sv-SE',
    country: 'Sweden',
  },
  'sg-en': {
    locale: 'en-US',
    country: 'Singapore',
  },
  'sg-zh': {
    locale: 'en-US',
    country: 'Singapore',
  },
  'si-en': {
    locale: 'en-US',
    country: 'Slovenia',
  },
  'si-sl': {
    locale: 'en-US',
    country: 'Slovenia',
  },
  'sk-en': {
    locale: 'en-US',
    country: 'Slovakia',
  },
  'sk-sk': {
    locale: 'en-US',
    country: 'Slovakia',
  },
  sl: {
    locale: 'en-US',
    country: 'Sierra_Leone',
  },
  'sm-en': {
    locale: 'en-US',
    country: 'San_Marino',
  },
  'sm-it': {
    locale: 'it-IT',
    country: 'San_Marino',
  },
  'sn-en': {
    locale: 'en-US',
    country: 'Senegal',
  },
  'sn-fr': {
    locale: 'fr-FR',
    country: 'Senegal',
  },
  'sr-en': {
    locale: 'en-US',
    country: 'Suriname',
  },
  'sr-nl': {
    locale: 'nl-NL',
    country: 'Suriname',
  },
  'st-en': {
    locale: 'en-US',
    country: 'Sao_Tome_and_Principe',
  },
  'st-pt': {
    locale: 'en-US',
    country: 'Sao_Tome_and_Principe',
  },
  sv: {
    locale: 'es-LA',
    country: 'El_Salvador',
  },
  sz: {
    locale: 'en-US',
    country: 'Eswatini',
  },
  'td-en': {
    locale: 'en-US',
    country: 'Chad',
  },
  'td-fr': {
    locale: 'fr-FR',
    country: 'Chad',
  },
  'tg-en': {
    locale: 'en-US',
    country: 'Togo',
  },
  'tg-fr': {
    locale: 'fr-FR',
    country: 'Togo',
  },
  'th-en': {
    locale: 'en-US',
    country: 'Thailand',
    phonePrefix: '+66',
  },
  'th-th': {
    locale: 'th-TH',
    country: 'Thailand',
    phonePrefix: '+66',
  },
  'tj-en': {
    locale: 'en-US',
    country: 'Tajikistan',
  },
  'tj-ru': {
    locale: 'ru-RU',
    country: 'Tajikistan',
  },
  'tl-en': {
    locale: 'en-US',
    country: 'Timor-Leste',
  },
  'tl-pt': {
    locale: 'en-US',
    country: 'Timor-Leste',
  },
  'tn-ar': {
    locale: 'ar',
    country: 'Tunisia',
  },
  'tn-fr': {
    locale: 'fr-FR',
    country: 'Tunisia',
  },
  to: {
    locale: 'en-US',
    country: 'Tonga',
  },
  'tr-en': {
    locale: 'en-US',
    country: 'Turkey',
  },
  'tr-tr': {
    locale: 'tr-TR',
    country: 'Turkey',
  },
  tt: {
    locale: 'en-US',
    country: 'Trinidad_and_Tobago',
  },
  tv: {
    locale: 'en-US',
    country: 'Tuvalu',
  },
  tw: {
    locale: 'zh-TW',
    country: 'Taiwan',
  },
  'tz-en': {
    locale: 'en-US',
    country: 'Tanzania',
    phonePrefix: '+255',
  },
  'tz-sw': {
    locale: 'en-US',
    country: 'Tanzania',
    phonePrefix: '+255',
  },
  'ua-en': {
    locale: 'en-US',
    country: 'Ukraine',
  },
  'ua-uk': {
    locale: 'en-US',
    country: 'Ukraine',
  },
  'ug-en': {
    locale: 'en-US',
    country: 'Uganda',
    phonePrefix: '+256',
  },
  'ug-sw': {
    locale: 'en-US',
    country: 'Uganda',
    phonePrefix: '+256',
  },
  uk: {
    locale: 'en-US',
    country: 'United_Kingdom',
  },
  us: {
    locale: 'en-US',
    country: 'United_States',
  },
  uy: {
    locale: 'es-LA',
    country: 'Uruguay',
  },
  uz: {
    locale: 'en-US',
    country: 'Uzbekistan',
  },
  vc: {
    locale: 'en-US',
    country: 'St._Vincent_and_the_Grenadines',
  },
  've-en': {
    locale: 'en-US',
    country: 'Venezuela,_RB',
  },
  've-es': {
    locale: 'es-LA',
    country: 'Venezuela,_RB',
  },
  'vn-en': {
    locale: 'en-US',
    country: 'Vietnam',
    phonePrefix: '+84',
  },
  'vn-vi': {
    locale: 'vi-VN',
    country: 'Vietnam',
    phonePrefix: '+84',
  },
  'vu-en': {
    locale: 'en-US',
    country: 'Vanuatu',
  },
  'vu-fr': {
    locale: 'fr-FR',
    country: 'Vanuatu',
  },
  ws: {
    locale: 'en-US',
    country: 'Samoa',
  },
  'xk-en': {
    locale: 'en-US',
    country: 'Kosovo',
  },
  'xk-sr': {
    locale: 'en-US',
    country: 'Kosovo',
  },
  'za-en': {
    locale: 'en-US',
    country: 'South_Africa',
    phonePrefix: '+27',
  },
  'za-zu': {
    locale: 'en-US',
    country: 'South_Africa',
    phonePrefix: '+27',
  },
  zm: {
    locale: 'en-US',
    country: 'Zambia',
  },
  zw: {
    locale: 'en-US',
    country: 'Zimbabwe',
  },
};
